// Libraries
import moment from 'moment'

// Utilities
import isEmpty from '../../utility/isEmpty'
import { OfferIdEnum, ServiceBrands } from '../../constants'

export default {
  recognizedOffers (state) {
    const offerIds = Object.values(OfferIdEnum)
    return Array.isArray(state.offers) ? state.offers.filter(offer => offerIds.indexOf(offer.offerId) > -1) : []
  },

  getStyles: (state) => (textSection) => {
    let styles = ''

    if (!isEmpty(textSection)) {
      if (!isEmpty(textSection.weight)) {
        if (textSection.weight === 'bold') {
          styles = 'text-600'
        } else if (textSection.weight === 'light') {
          styles = 'text-300'
        }
      }

      if (!isEmpty(textSection.size)) {
        styles += ` text-${textSection.size}`
      }

      if (!isEmpty(textSection.style)) {
        if (textSection.style === 'italic') {
          styles += ' text-italic'
        } else if (textSection.style === 'underline') {
          styles += ' text-underline'
        }
      }

      if (!isEmpty(textSection.lineBreak)) {
        styles += ' block text-white'
      }

      if (!isEmpty(textSection.newLine) && textSection.newLine === true) {
        styles += ' block'
      }
    }

    return styles
  },

  settlementOffer (state) {
    if (isEmpty(state.offers)) {
      return undefined
    }

    return state.offers.find(offer => !isEmpty(offer.offerId) && offer.offerId === OfferIdEnum.settlement)
  },

  settlementOfferExpired (state, getters) {
    const settlementOffer = getters.settlementOffer

    if (isEmpty(settlementOffer) || isEmpty(settlementOffer.docExp)) {
      return false
    }

    return moment(settlementOffer.docExp).isBefore(moment())
  },

  settlementOfferLoan (state, getters, rootState, rootGetters) {
    const settlementOffer = getters.settlementOffer

    if (isEmpty(rootState.loans.loans) || isEmpty(settlementOffer) || isEmpty(settlementOffer.targetLoanId)) {
      return undefined
    }

    return rootGetters['loans/getLoanById'](settlementOffer.targetLoanId)
  },

  settlementOfferLoanBrand (state, getters, rootState, rootGetters) {
    const loan = getters.settlementOfferLoan

    if (isEmpty(loan)) {
      return 'TitleMax'
    }

    const loanBrand = rootGetters['store/getStoreBrand'](loan.storeId)

    if (isEmpty(loanBrand)) {
      return 'TitleMax'
    }

    return loanBrand
  },

  settlementOfferPageBrand (state, getters) {
    return getters.settlementOfferLoanBrand.toLowerCase() === ServiceBrands.InstaLoan.toLowerCase() ? 'InstaLoan' : 'TitleMax'
  },

  appraisalOffer (state) {
    if (isEmpty(state.offers)) {
      return undefined
    }

    return state.offers.find(offer => !isEmpty(offer.offerId) && offer.offerId === OfferIdEnum.appraisal)
  },

  appraisalOfferAmount (state, getters) {
    if (isEmpty(getters.appraisalOffer)) {
      return undefined
    }

    return parseFloat(getters.appraisalOffer.qualifiedAmount)
  },

  appraisalOfferLoan (state, getters, rootState, rootGetters) {
    const appraisalOffer = getters.appraisalOffer

    if (isEmpty(rootState.loans.loans) || isEmpty(appraisalOffer) || isEmpty(appraisalOffer.targetLoanId)) {
      return undefined
    }

    return rootGetters['loans/getLoanById'](appraisalOffer.targetLoanId)
  },

  appraisalOfferLoanBrand (state, getters, rootState, rootGetters) {
    const loan = getters.appraisalOfferLoan
    if (isEmpty(loan)) {
      return 'TitleMax'
    }

    const loanBrand = rootGetters['store/getStoreBrand'](loan.storeId)
    if (isEmpty(loanBrand)) {
      return 'TitleMax'
    }

    return loanBrand
  },

  appraisalOfferPageBrand (state, getters) {
    return getters.appraisalOfferLoanBrand.toLowerCase() === ServiceBrands.InstaLoan.toLowerCase() ? 'InstaLoan' : 'TitleMax'
  }
}
